/**
 * Safe way to extract property names from a class
 * @param Tobj Should be a class name
 * @returns Interface
 */
export function proxiedPropertiesOf<TObj>(obj?: TObj) {
    return new Proxy(
        {},
        {
            get: (_, prop) => prop,
            set: () => {
                throw Error('Set not supported');
            },
        },
    ) as {
        [P in keyof TObj]?: P;
    };
}

export interface Loading {
    loadingId?: number;
    loadingStatus: boolean;
    loadingMessage?: string;
    pending: number;
}
